import type { GestureResponderEvent } from 'react-native'
import { Button, type IButtonProps } from '~/components/button'

import { useInputTextProps } from '../../hooks'
import type { TTextInputSizes } from '../../types'
import * as Comp from './input-button.styles'

export function InputTextButton({
  onPress,
  testID,
  ...props
}: Omit<IButtonProps, 'children'>) {
  const { size = 'md', isActive, isFilled, onChangeText } = useInputTextProps()

  const iconSizeMapping: Record<TTextInputSizes, IButtonProps['size']> = {
    md: 'md',
    ml: 'ml',
    lg: 'ml',
    xl: 'ml',
  }

  function handlePress(event: GestureResponderEvent) {
    onChangeText?.('')
    onPress?.(event)
  }

  if (!isFilled) return null
  return (
    <Comp.Button isActive={!isFilled || isActive === false}>
      <Button.Root
        {...props}
        variant="neutral-tertiary"
        size={iconSizeMapping[size]}
        onPressIn={handlePress}
        onPressOut={handlePress}
        testID={testID}
      >
        <Button.Icon symbol="rdicon-dismiss-circle-outline" />
      </Button.Root>
    </Comp.Button>
  )
}
